export const HOME_PAGE_CATEGORY_FILTER_SELECTED = 'Home Page Category Filter Selected';

export function homePageCategoryFilterSelectedEventProperties(options: {
  categoryName: string;
}): Record<string, string> {
  return {
    'Category Name': options.categoryName,
  };
}
